import React, { FunctionComponent, useState, useEffect } from 'react';
import styled from 'styled-components';
import MessageAlert from '../../../../ui/components/MessageAlert';
import { useCreditsContext } from '../../../pricing/CreditsContext';
import Accordion from '../../../../ui/components/Accordion';
import { useMediaQuery } from '@mui/material';

const MessageContainer = styled.div`
    position: absolute;
    display: flex;
    top: 5px;
    left: 50%;
    min-width: 80vw;
    max-width: 100%;
    transform: translateX(-50%);
    z-index: 1000;
`;

interface GameRuntimeErrorProps {
    errors: string[];
    handleTryToFix: () => void;
    handleUndoClick: () => void;
    canUndo: boolean;
    isGeneratingGame: boolean;
    isUpdatingGameArt: boolean;
    handleCloseErrorPopup: () => void;
}

const ENABLE_RUNTIME_ERROR_POPUP = true;

const GameRuntimeError: FunctionComponent<GameRuntimeErrorProps> = ({
    errors,
    handleTryToFix,
    handleUndoClick,
    canUndo,
    isGeneratingGame,
    isUpdatingGameArt,
    handleCloseErrorPopup,
}) => {
    const [open, setOpen] = useState(false);
    const [title, setTitle] = useState('');
    const [body, setBody] = useState<string[]>([]);
    const { isOutOfCredits } = useCreditsContext();
    const isMobile = useMediaQuery('(max-width: 600px)');

    useEffect(() => {
        if (ENABLE_RUNTIME_ERROR_POPUP) {
            if (errors && errors.length > 0) {
                // console.log('DEBUG RUNTIME ERRORS: ', errors);
                setOpen(true);
                setTitle('GAME ERROR' + (errors.length >= 2 ? 'S (' + errors.length + ')' : ''));
                setBody(['Something went wrong.']);
            } else {
                setOpen(false);
                setTitle('');
                setBody([]);
            }
        }
    }, [errors]);

    const onTryToFixClick = () => {
        // TODO: Implement try to fix
        if (handleTryToFix) {
            handleTryToFix();
        }
        setOpen(false);
    };

    const onUndoClick = () => {
        // TODO: Implement undo
        if (handleUndoClick) {
            handleUndoClick();
        }
        setOpen(false);
    };

    const onClose = () => {
        setOpen(false);
        if (handleCloseErrorPopup) {
            handleCloseErrorPopup();
        }
    };

    if (!open) {
        return null;
    }

    return (
        isGeneratingGame ? (
            <></>
        ) : (
            <MessageContainer>
                <MessageAlert
                    titleText={isMobile ? title : null}
                    bodyText={isMobile ? body : null}
                    children={
                        isMobile ? (
                            <></>
                        ) : (
                            <Accordion 
                                size="medium"
                                colorMode="light"
                                style="ghost"
                                title={title}
                                subtitle={body.join('\n')}
                                content={errors.join('\n')}
                            />
                        )
                    }
                    color="red"
                    colorMode="light"
                    size="small"
                    includeClose={true}
                    onClose={onClose}
                    secondaryButton={canUndo ? {
                        text: 'Undo',
                        // icon: 'arrow-u-up-left',
                        onClick: onUndoClick,
                    } : undefined}
                    primaryButton={{
                        text: 'Try to Fix',
                        onClick: onTryToFixClick,
                        disabled: isGeneratingGame || isOutOfCredits.game_edit_limited || isUpdatingGameArt,
                    }}
                />
            </MessageContainer>
        )
    );
};

export default GameRuntimeError;